var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRUDPage',{attrs:{"resultHeaders":_vm.resultHeaders,"resource":"transparency/code1","title":"透明性GLコード1一覧","schemaName":"TransparencyGlCode1","searchParamsProp":{sort: 'code1'}},scopedSlots:_vm._u([{key:"pageheader",fn:function(){return [_c('TransparencyMenu')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }